import React from 'react'

export const TaxesStructure = () => {
  return (
    <>
      <div className='max-w-[1170px] relative m-auto px-5 '>
<div className='mt-[50px]'>
    <div className='title font-ibm-plex-sans flex'>
   <span className=''>Tax<div className='py-[3px] rounded bg-[#009969] w-[120px]'></div> </span> Structure
    </div>
    <div className='text-[22px] leading-[24px] text-[#40384F] my-[30px]'>
    Mining fiscal regimes are almost exclusively a mix of income-based taxes and royalties. Whereas royalties become payable as soon as production starts, income taxes are only payable once the company begins to realise net profits. 
    </div>
</div>
<div className='my-[50px]'>
    <div>
        <span className='bg-[#009969] p-3 text-[36px] rounded-lg text-white font-ibm-plex-sans leading-[60px] font-medium'>1. Income Tax</span>
    </div>
    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>1.1 Rate of Corporate Tax</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>The Government embarked upon a progressive reduction in the effective rate of corporate tax. The applicable rate of tax as regulated under the Income Tax Ordinance, 2001, is 35% for companies.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>1.2 Minimum Corporate Tax</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>A minimum amount of corporate tax is payable annually at the rate of 1.0% of the declared turnover by resident companies. However, where the corporate tax payable exceeds this amount in any year, the minimum tax is not charged.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>1.3 Exemption from taxation on refining or concentration of mineral deposits:</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Exemption from taxation on profits from refining or concentrating mineral deposits is also allowed at the rate and for the period prescribed under tax laws.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>1.4 Pre-commencement expenditure</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Expenditure incurred before commencement of business including feasibility studies etc., is also allowed to be amortized on a straight line basis at the specified rates.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>1.4 Pre-commencement expenditure</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Expenditure incurred before commencement of business including feasibility studies etc., is also allowed to be amortized on a straight line basis at the specified rates.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>1.5 Development Expenditure Deduction and Loss Carry Forward</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Expenditure incurred on exploration operations qualifies for immediate deduction in the determination of taxable income. Expenditure incurred for project development operations will be allowed deduction at a rate of 25% per annum, in line with international practice. However, the depletion allowance will be allowed as per provision of current tax laws.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>1.6 Ring-Fencing</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>A mining company will be assessed for income tax on the entirety of its mining operations in Pakistan.</div>
    </div>
</div>

<div className='my-[50px]'>
    <div>
        <span className='bg-[#009969] p-3 text-[36px] rounded-lg text-white font-ibm-plex-sans leading-[60px] font-medium'>2. Withholding Taxes</span>
    </div>
    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>2.1 Dividends</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Except where lower rates are specified in the Avoidance of Double Taxation Treaty with the country of the recipient, the withholding tax levied on dividends paid is 10%.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>2.2 Non-Resident Contractors</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>The rate of withholding tax is 6% on payments made either in full or part to a non-resident on the execution of a contract or sub-contract under a construction, assembly or installation project in Pakistan, including a contract for the supply of supervisory activities in relation to such project. The tax collected shall be a final tax if the contractor furnishes on option under clause (4) of the Part-IV of the Second Schedule to the Income Tax Ordinance, 2001. 16</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>2.3 Interest</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Interest paid to non-residents in <br/> respect of availed approved loans is <br/> exempt from withholding tax.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>2.4 Royalty & Fee for Technical Services</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Tax @ 15% shall be deducted from the gross amount paid to a non-resident person on account of royalty and fee for technical services.</div>
    </div>

    
</div>

<div className='my-[50px]'>
    <div>
        <span className='bg-[#009969] p-3 text-[36px] rounded-lg text-white font-ibm-plex-sans leading-[60px] font-medium'>3. Other Taxes</span>
    </div>
    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>3.1 Sales Tax</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>Mining companies shall be liable to pay general sales tax at the rate prescribed by the Government from time to time.</div>
    </div>

    <div className='my-8'>
        <div className='font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3'>3.2 Additional Profits Tax (APT)</div>
        <div className='text-[22px] leading-[24px] text-[#40384F] '>An Additional Profits Tax is payable by large scale mining companies at agreed rates based on the economic projections as stipulated in the agreement with the Government. The APT will be determined based on a three-tier mechanism and will be payable only when the mining project achieves the agreed threshold level of profitability. The three-tier mechanism is summarized below:-</div>
    </div>

   <div className='grid grid-cols-2   max-w-[888px] relative m-auto mt-[50px] mb-[170px]'>
<div className='bg-[#27AE60] mr-[20px] text-white rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>Rate of Return (ROR) Threshold</div>
<div className='bg-[#27AE60] text-white rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>Resource Rent Tax (RRT) Rate</div>
<div className='bg-[#F4FBF7] mr-[20px] mt-[10px] text-[#40384F] rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>10%</div>
<div className='bg-[#F4FBF7]  mt-[10px] text-[#40384F] rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>10%</div>
<div className='bg-[#F4FBF7] mr-[20px] mt-[10px] text-[#40384F] rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>20%</div>
<div className='bg-[#F4FBF7]  mt-[10px] text-[#40384F] rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>15%</div>
<div className='bg-[#F4FBF7] mr-[20px] mt-[10px] text-[#40384F] rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>25%</div>
<div className='bg-[#F4FBF7]  mt-[10px] text-[#40384F] rounded-md font-medium text-[24px] leading-[36px] p-2 text-center'>18%</div>
   </div>

    
</div>
      </div>
    </>
  )
}


